import React from 'react';
import { Box, FormError, TextArea, TextAreaProps } from 'pounceV2';
import { FieldConfig, useField } from 'formik';
import { safeguardErrorMsg } from '../utils';

export const FormikTextAreaV3: React.FC<
  TextAreaProps & Required<Pick<FieldConfig, 'name'>>
> = props => {
  const [field, meta] = useField(props.name);

  const isInvalid = meta.touched && !!meta.error;
  const errorElementId = isInvalid ? `${props.name}-error` : undefined;
  return (
    <Box>
      <TextArea
        invalid={isInvalid}
        aria-describedby={isInvalid ? errorElementId : undefined}
        {...field}
        {...props}
      />
      {isInvalid && (
        <FormError mt={2} id={errorElementId}>
          {safeguardErrorMsg(meta.error)}
        </FormError>
      )}
    </Box>
  );
};
